import { createAction } from 'redux-actions';
import { replace } from 'react-router-redux';

import { openFailedAlert } from 'actions/alert';
import { updateApartmentByRoom } from 'actions/apartment';
import { wrapFetch } from 'actions/endpoint';

import { defaultRoomData } from 'reducers/room';
import { keyTransform } from 'util/helper';

export const updateRoomByApartment = createAction('UPDATE_ROOM', room => (_, getState) => {
	const newRoom = keyTransform(room);
	const oldRoom = getState().room.data[room.id] || defaultRoomData;

	return {
		[newRoom.id]: {
			...defaultRoomData,
			...oldRoom,
			...newRoom,
		},
	};
});

export const getRoom = createAction('FETCH_ROOM', (query = {}) => async dispatch => {
	const { mrt_line: _, ...useedQuery } = query;

	const { status, message, data } = await wrapFetch('room', { method: 'GET' }, useedQuery);

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const newData = {};
	const list = data.data.map(item => {
		newData[item.id] = {
			...defaultRoomData,
			...keyTransform(item),
		};
		const { apartment } = newData[item.id];
		newData[item.id].apartment = undefined;

		dispatch(updateApartmentByRoom(apartment, item.id));

		return item.id;
	});

	return {
		list,
		data: newData,
		currentPage: data.current_page,
		lastPage: data.last_page,
		perPage: data.per_page,
		total: data.total,
	};
});

export const getMoreRoom = createAction('FETCH_MORE_ROOM', () => async (dispatch, getState) => {
	const { routing: { locationBeforeTransitions: { query } }, room: { currentPage } } = getState();

	const { status, message, data } = await wrapFetch(
		'room',
		{ method: 'GET' },
		{ ...query, page: currentPage + 1 },
	);

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const newData = {};
	const list = data.data.map(item => {
		newData[item.id] = {
			...defaultRoomData,
			...keyTransform(item),
		};
		const { apartment } = newData[item.id];
		newData[item.id].apartment = undefined;

		dispatch(updateApartmentByRoom(apartment, item.id));

		return item.id;
	});

	return {
		list,
		data: newData,
		currentPage: data.current_page,
		lastPage: data.last_page,
		perPage: data.per_page,
		total: data.total,
	};
});

export const getRoomById = createAction('FETCH_ROOM_BY_ID', id => async dispatch => {
	const { status, data } = await wrapFetch(`room/${id}`, {
		method: 'GET',
	});

	if (status !== 200) {
		dispatch(replace({ pathname: '/404' }));
		return { data: {}, recommend: [] };
	}

	const newData = {
		...defaultRoomData,
		...keyTransform(data.data),
	};

	dispatch(updateApartmentByRoom(newData.apartment, newData.id));
	newData.apartment = undefined;

	const recommend = data.recommend.map(item => {
		dispatch(updateRoomByApartment(item));

		return item.id;
	});

	return { data: { [newData.id]: newData }, recommend };
});



// WEBPACK FOOTER //
// ./src/actions/room.js